import getColor from "utils/getColor";
import { getPrimaryColor } from "utils/themeConfig";

import CustomLink from "../elements/custom-link";

import styles from "@/styles/cards.module.scss";

const IconRows = ({ data }) => {
  const arrow = (
    <svg
      className="inline-block"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41785 10.0002L5.91532 5.49747L1.41785 1"
        stroke={getPrimaryColor()}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  const Circle = ({ color }) => (
    <svg
      width="70"
      height="69"
      viewBox="0 0 70 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        r="27.7353"
        transform="matrix(0 -1 -1 0 35 34.5)"
        stroke={color}
        strokeWidth="13.5294"
      />
    </svg>
  );

  return (
    <div className="container max-screen-w-xl text-left p-10">
      <h1 className={styles.mainTitle}>{data.title}</h1>
      <h5 className={styles.mainSubTitle}>{data.subTitle}</h5>
      <div className=" my-5 grid grid-cols-1 md:grid-cols-3 text-center gap-5">
        {data.cards.map((v, i) => (
          <div className={`flex flex-row`} key={i}>
            <div
              className="flex w-32 justify-center "
              style={{ borderRadius: "10px", overflow: "hidden" }}
            >
              <Circle color={getColor(v.iconColor?.colors)} />
            </div>
            <div className="text-left">
              <h5 className={`px-5 ${styles.cardTitle}`}>{v.title}</h5>
              <small className={`px-5 ${styles.smallText}`}>{v.subTitle}</small>
              <p className={`grow px-5 ${styles.cardDescription}`}>
                {v.description}
              </p>
              <p className="text-onmoPrimary mt-5 px-5 mb-4">
                {v.link === null ? null : (
                  <>
                    <CustomLink link={v.link}>
                      <span className="underline underline-offset-2">
                        {v.link.text}
                      </span>{" "}
                      {arrow}
                    </CustomLink>{" "}
                  </>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IconRows;
